export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-label-1200-5e8710100d92c7c1749b8aaec3e00bbc.png";